export default "__VITE_ASSET__BsSh3OsK__"